// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDxpZmy4ga_1U8nlItS5O9_L0dh5TOYg_g",
  authDomain: "emailmarketingai-27b1a.firebaseapp.com",
  projectId: "emailmarketingai-27b1a",
  storageBucket: "emailmarketingai-27b1a.firebasestorage.app",
  messagingSenderId: "1021592429598",
  appId: "1:1021592429598:web:b8a094f3b8733db9e27a0f"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;
